/**
 * Zod adapters for the branded ids, for every contract that crosses a wire (design 12.2:
 * "exported as types plus a zod schema where they cross a wire").
 *
 * The check is the id codec's own `is`, not a zod format helper: the format helpers have
 * moved between zod majors, and one definition of "a WeTalk id" is better than two.
 */
import { z } from "zod";
/** Builds the schema for one branded id from its codec. Rejects a malformed or nil UUID. */
export function idSchema(codec) {
    return z
        .string()
        .refine((value) => codec.is(value), {
        message: `must be a non-nil UUID (${codec.brandName})`,
    })
        .transform((value) => value);
}
//# sourceMappingURL=schema.js.map